import React, { useRef, useState } from 'react';
import { Box, VisuallyHidden } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { SidebarItem } from './SidebarItem';
import { localise } from '../../../services/lang/lang';
import Chevron, { ChevronDirection } from '../../icons/Chevron';
import { useTokens } from '../../../context/TokenProvider';
import VStackWrapper from '../VStackWrapper/VStackWrapper';
import { RenderIf } from '../RenderIf/RenderIf';
const Sidebar = (props) => {
    const history = useHistory();
    const toggleSwitchRef = useRef(null);
    const [menuOpened, setMenuOpened] = useState(true);
    const tokens = useTokens();
    const toggleMenu = (isToggled) => {
        setMenuOpened((prev) => !prev);
        const toggleSwitch = toggleSwitchRef.current;
        if (toggleSwitch) {
            toggleSwitch.style.display = 'none';
            setTimeout(() => {
                toggleSwitch.style.display = '';
                toggleSwitch.focus();
            }, 0);
        }
        props.onSidebarToggled(isToggled);
    };
    const goTo = (link) => () => history.push(link);
    const getSidebarIconOrientation = () => props.isSidebarToggled ? ChevronDirection.LEFT : ChevronDirection.RIGHT;
    const sideBarStyles = {
        sidebarToggle: {
            cursor: 'pointer',
            position: 'absolute',
            left: props.isSidebarToggled ? '315px' : '52px',
            top: '20px',
            background: 'white',
            borderRadius: '50%',
            borderColor: tokens.BorderLight200,
            borderWidth: tokens.BorderWidth01,
            height: '30px',
            width: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingRight: props.isSidebarToggled ? '2px' : 0,
            paddingLeft: props.isSidebarToggled ? 0 : '2px',
            _focus: {
                outline: 'none',
                boxShadow: 'none',
            },
            _focusVisible: {
                boxShadow: 'none',
                outline: `1px solid ${tokens.BorderFocus}`,
                outlineOffset: tokens.Spacing01,
            },
        },
    };
    return (React.createElement(VStackWrapper, { variant: "sidebar" },
        React.createElement(RenderIf, { condition: props.showToggle },
            React.createElement(Box, { ref: toggleSwitchRef, onClick: () => {
                    toggleMenu(!props.isSidebarToggled);
                }, sx: sideBarStyles.sidebarToggle, tabIndex: 0, "aria-label": localise('TOGGLE_SIDEBAR'), "aria-expanded": menuOpened, "data-testid": "sidebar_subnav_toggle_icon", role: "button" },
                React.createElement(Chevron, { width: "18", height: "18", direction: getSidebarIconOrientation() })),
            React.createElement(VisuallyHidden, { "aria-live": "polite" }, menuOpened ? localise('MENU_OPENED') : localise('MENU_CLOSED'))),
        React.createElement(SidebarItem, { labelName: localise('DASHBOARD'), icon: "inspections", selected: props.selected === 'inspections', onClick: goTo('/inspections') }, localise('DASHBOARD')),
        React.createElement(SidebarItem, { icon: "cog", selected: props.selected === 'settings', onClick: goTo('/settings/organisation-profile/general'), labelName: localise('SETTINGS') }, localise('SETTINGS'))));
};
export default Sidebar;
